import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../util/reactIntl';
import { Avatar, Ratings, Button, IconCollection } from '../../../components';

import css from './AboutAuthor.module.css';
import classNames from 'classnames';
import { createResourceLocatorString } from '../../../util/routes';
import { generateCitySlug, generateStoreSlug } from '../../../util/seo';

const BIO_MAX_LENGTH = 180;

function truncate(text, maxLength) {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + '…' : text;
}

const AboutAuthor = ({ profile, verified, intl, history, routeConfiguration }) => {
    if (!profile) return null;
    const publicData = profile?.attributes?.profile?.publicData || {};
    const displayName = publicData.storeName || profile?.attributes?.profile?.displayName || '';
    const city = publicData.city || '';
    const memberSince = profile?.attributes?.createdAt
        ? new Date(profile.attributes.createdAt).getFullYear()
        : '';
    const bio = profile?.attributes?.profile?.bio || '';
    const avatarUser = profile;
    const verifiedLabel = intl.formatMessage({ id: 'AboutOwner.verified' });

    const visitStoreLabel = intl.formatMessage({ id: 'AboutOwner.visitStore' });

    const visitStoreHandler = () => {
        const citySlug = generateCitySlug(publicData?.storeAddress?.city || publicData?.city);
        history.push(
            createResourceLocatorString(
                'ProfilePage',
                routeConfiguration,
                {
                    ...(citySlug ? { city: citySlug } : {}),
                    slug: generateStoreSlug(publicData.storeName),
                    id: profile.id.uuid
                }
            )
        )
    };

    return (
        <>

            <div className={classNames(css.panel)}>
                <div className={css.header}>
                    <h4 className={css.heading}>
                        <FormattedMessage id="AboutAuthor.aboutTheAuthor" defaultMessage="About The Author" />
                    </h4>
                    <div className={css.buttonGroup}>
                        <Button type="button" onClick={visitStoreHandler} size={"sm"} className={css.infoButton} variant="info" arrow='right' icon={<IconCollection name="arrow_righ_stright" />}>
                            {visitStoreLabel}</Button>
                    </div>
                </div>
                <div className={css.avatarWrapper}>
                    <Avatar user={avatarUser} renderSizes="48px" className={css.avatar} />
                    <div className={css.ownerRightContent}>
                        <div className={css.nameWithBadge}>
                            <span >{displayName}</span>
                            {verified && (
                                <span className={css.badge}>
                                    <IconCollection name="profile_varified" />
                                    <span className={css.desktopLabel}>{verifiedLabel}</span></span>
                            )}
                        </div>
                        <div className={css.memberSince}>
                            {/* <FormattedMessage id="AboutOwner.memberSince" defaultMessage="Member since {year}" values={{ year: memberSince }} />
                             */}
                            {city ? `From ${city}` : memberSince ? `Member since ${memberSince}` : ''}
                        </div>

                    </div>
                </div>
                <div className={css.bio}>
                    {truncate(bio, BIO_MAX_LENGTH)}
                </div>

            </div>

        </>

    );
};

AboutAuthor.propTypes = {
    profile: PropTypes.object,

    verified: PropTypes.bool,
    intl: PropTypes.object.isRequired,
};

export default AboutAuthor;
